import { Severity } from '~/pages/event-center/shared/types'
import { createTelemetryAPI } from '~/utils/telemetry'

export const eventCenterTelemetry = createTelemetryAPI(({ track }) => ({
  clickTabs(goto: string) {
    return track('Event Center: Click Tabs', { goto })
  },
  zoomOutChart(groupId: string, from: number, to: number) {
    return track('Event Center: Zoom Out Chart', { groupId, from, to })
  },
  resetChart(groupId: string, from: number, to: number) {
    return track('Event Center: Reset Chart', { groupId, from, to })
  },
  refreshChart(groupId: string, from: number, to: number) {
    return track('Event Center: Refresh Chart', { groupId, from, to })
  }
}))

export const recentEventTelemetry = createTelemetryAPI(({ track }) => ({
  changeSeverity(severity: Severity) {
    return track('Recent Events: Change Severity', { severity })
  },
  clickCollapse(open: boolean, groupId: string) {
    return track('Recent Events: Click Event Collapse Button', {
      open,
      groupId
    })
  },
  clickOOMInsight(groupId: string) {
    return track('Recent Events: Go to OOM Insight Detail', { groupId })
  }
}))

export const historicalEventTelemetry = createTelemetryAPI(({ track }) => ({
  searchEvent(name: string) {
    return track('Historical Event: Search Event', { name })
  },
  changeSeverity(severity: Severity) {
    return track('Historical Event: Change Severity', { severity })
  },
  changeTimeRange(from: string, to: string) {
    return track('Historical Event: Change Time Range', { from, to })
  },
  clickDetail(groupId: string, eventId: string) {
    return track('Historical Event: Click Detail', { groupId, eventId })
  }
}))

export const eventDetailTelemetry = createTelemetryAPI(({ track }) => ({
  clickBreadcrumbs() {
    return track('Event Detail: Click Breadcrumbs to Historical Page')
  }
}))
